export const productCardCruisesDesktopConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { summary , itinerary , link ={
        href: ''
    } , config , price , rating , tag , icons =[] , logo  } = data;
    const _icons = icons.map(({ icon =''  })=>({
            icon
        }));
    const descriptions = summary?.details?.flatMap(({ content =''  })=>content) ?? [];
    const moreInfo = itinerary?.details?.map(({ content =''  })=>({
            content
        })) ?? [];
    const companies = logo ? [
        {
            ...logo
        }
    ] : [];
    const _rating = typeof rating === 'number' ? rating : rating?.value;
    const fromCaption = typeof price?.from === 'string' ? price?.from : price?.fromText;
    return {
        ...data,
        config: {
            ...config,
            deal: config?.deal,
            icon: !!config?.icon,
            iconName: config?.icon,
            soldOut: props.soldOut,
            literals: {
                fromCaption,
                summary: summary?.tab_name,
                moreInfo: itinerary?.tab_name
            }
        },
        image: summary?.image ?? {
            src: ''
        },
        descriptions,
        moreInfo,
        secondaryImage: itinerary?.image,
        link,
        price: {
            value: price?.value,
            from: !!price?.from
        },
        title: summary?.title ?? '',
        subtitle: summary?.subtitle,
        rating: _rating,
        tag,
        icons: _icons,
        companies
    };
};

//# sourceMappingURL=converter.js.map